module.exports = __webpack_public_path__ + "img/article-daily-share-cover.40040311.png";